module.exports = __webpack_public_path__ + "static/media/image11.913b0cd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image11.jpg
// module id = 45
// module chunks = 0